// Form initial values

export const initialValues = {
    pep: {
        pregunta1: {
            actividad: 58,
            modo: 9,
            nombreCargo: "",
            pais: "",
            nombreEnteAdscrito: "",
            pregunta: 1,
            respuesta: ''
        },
        hasAssociate: '',
        pregunta2: [
            {
                direccionFiscal: "",
                documentoIdentidad: "",
                genero: "",
                lugarNacimiento: '',
                modo: 9,
                nacionalidad: '',
                nombreCargo: "",
                pais: '',
                nombreEnteAdscrito: "",
                nombrePersona: "",
                pregunta: 2,
                profesion: '',
                respuesta: 'si',
                telefono: '',
                tipoDeRelacion: '',
                otraNacionalidad: "",
                fechaNacimiento: "",
                tipoLugarNacimiento: "V",
                asociadoId: 1,
                cantidad: 1
            }
        ]
    },
    fatca: {
        tieneRelacion: '',
        numitin: '',
    },
    hasBankReference: '',
    bankReference: {
        tipoBanco: '',
        fechaApertura: '',
        fechaConstancia: '',
        numero: '',
        banco: {
            codigo: '',
            descripcion: ''
        },
        tipoCuenta: '',
        numeroCuenta: '',
        numeroCifras: '',
        calificacion: {
            codigo: '',
            descripcion: ''
        },
        tipoCifras: {
            codigo: '',
            descripcion: ''
        },
        tipoReferencia: {
            codigo: 'B',
            descripcion: 'BANCARIA'
        },
        observacion: ''
    },
    personalReferences: [
        {
            searchedOnList: false,
            isOnList: false,
            idReferencia: 0,
            tipoDocumento: '',
            cedulaReferencia: '',
            nombre: '',
            primerApellido: '',
            segundoApellido: '',
            parentesco: '',
            codParentesco: '',
            tipoOperacion: 'A',
            direccion: '',
            telefonoDomicilio: '',
            telefonoOtro: '',
        }
    ]
};